import { WorkpackService } from 'client/services';

// Returns a deferred capabilities promise — does not block navigation.
// WorkpackForm uses <Await> + <Suspense> to render once resolved.
const loader = () => {
    return { capabilities: WorkpackService.getPdfCapabilities() };
};

export default loader;
